import "./styles.scss";
import { MaterialHero } from "../../components/static-page-components/material-hero";

function ContactHeader() {
  return <MaterialHero title="CONNECT WITH US" />;
}

export default ContactHeader;
